/** Persisted model-picker preference.
 *
 * The selected model must ride on EVERY message (send / regenerate / edit), so
 * the choice can't live only in ephemeral React state — a reload or remount
 * would silently revert it to "auto" and the backend would classify + auto-route
 * again. We persist it as a single last-used preference (not per-session) so the
 * picker keeps the user's choice across reloads and every message carries it.
 *
 * "auto" is the sentinel meaning "send no model field" → the backend's cost
 * router chooses per turn.
 *
 * Fail-soft: localStorage can throw (private mode, disabled storage, SSR). All
 * access is guarded so a storage failure degrades to the in-memory default
 * rather than breaking chat.
 */
const STORAGE_KEY = "artie.selectedModel";

export const DEFAULT_MODEL = "auto";

export function readSelectedModel(): string {
  try {
    return window.localStorage.getItem(STORAGE_KEY) || DEFAULT_MODEL;
  } catch {
    return DEFAULT_MODEL;
  }
}

export function writeSelectedModel(id: string): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, id);
  } catch {
    /* storage blocked — the in-memory state still drives this session */
  }
}
